export const intervalList = [
  { name: "3 minutos", value: 3 },
  { name: "5 minutos", value: 5 },
  { name: "10 minutos", value: 10 },
  { name: "15 minutos", value: 15 },
  { name: "20 minutos", value: 20 },
  { name: "30 minutos", value: 30 },
  { name: "40 minutos", value: 40 },
  { name: "45 minutos", value: 45 },
  { name: "1 hora", value: 60 },
  { name: "2 horas", value: 120 },
  { name: "3 horas", value: 180 },
  { name: "4 horas", value: 240 },
  { name: "6 horas", value: 360 },
  { name: "8 horas", value: 420 },
  { name: "12 horas", value: 720 },
];

export const findIntervalByValue = (value) => {
  return intervalList.find((entry) => entry.value === value);
};
